import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';
import { ActivityTypeItem, EconomyService } from '../../../services/economy.service';

@Component({
  selector: 'tt-check-list',
  templateUrl: './check-list.component.html',
  styleUrls: ['./check-list.component.css']
})
export class CheckListComponent implements OnInit {
    public checkListKeyno: string;

    public selectedBgCheckListSelection: string = 'HEAD';

    public edit?: Edit;

    public searchText: string = '';

    public selectListAutoCreateTables: AutoCreateTableItem[] = [];

    public selectListActivityTypes: ActivityTypeItem[] = [];

    public itemsListCheckItems: Item[] = [];

    public renumbering = false;

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService, private economy: EconomyService) {
        this.checkListKeyno = this.stateService.getStateParams()['checklist_keyno'];
    }

    private async loadEdit() {
        if (!!this.checkListKeyno) {
            this.edit = (await this.datatask.Post(541, { checklist_keyno: this.checkListKeyno }))[0];
        }
    }

    private async loadAutoCreateTables() {
        this.selectListAutoCreateTables = await this.datatask.Post(920);
    }

    private async loadActivitityTypes() {
        this.selectListActivityTypes = await this.economy.getActivityTypes();
    }

    private async loadCheckItems() {
        if (!this.edit) return;

        return this.itemsListCheckItems = await this.datatask.Post(542, { checklist_keyno: this.edit.checklist_keyno });
    }

    public async renumberChanges() {
        if (!!this.edit) {
            try {
                this.renumbering = true;

                await this.datatask.Post(568, { checklist_keyno: this.edit.checklist_keyno });

                this.loadCheckItems();
            } finally {
                this.renumbering = false;
            }
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(548, this.edit);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        await this.loadEdit();
        this.loadAutoCreateTables();
        this.loadActivitityTypes();
        this.loadCheckItems();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    checklist_keyno: string;
    checklist_name: string;
    checklist_description: string;
    autocreate: string;
    autocreate_table_name: string;
    activitytype_no: string;
    lock_to_portal_user_when_approved: string;
    paged: string;
    unique_checklist: string;
}

interface AutoCreateTableItem {
    autocreate_table_name: string;
}
